/**
 * @file チェックボックス必須判定
 */
'use strict';
// utility class


/**
 * @classname CheckboxOptionTypeView
 * @classdesc チェックボックス必須判定
 */
export default class CheckboxOptionTypeView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('CheckboxOptionTypeView.constructor');
		let checked = false;
		$e.find('input[type=radio]').each(function(idx, e){
			const $e = $(e);
			if($e.prop('checked')) checked = true;
		});
		if(!checked){
			$e.find('input').eq(0).prop('checked', true);
		}
	};
}
